
import {Purchase} from "@/models/base";
import {PurchaseService} from "@/services/purchase-service";
import Vue from "vue";
import {TranslateResult} from "vue-i18n";
import AppPurchaseSearch from "./PurchaseSearch.vue";
import AppPurchaseBrowse from "./PurchaseSearchBrowse.vue";
import {View} from "@/models/view";
import {UserConfigService, ViewService} from "@/services";
export default Vue.extend({
	data() {
		return {
			browseModalOpen: false,
			generalSettings: UserConfigService.getGeneralSettings(),
			view: null as View | null
		};
	},
	props: {
		label: {
			type: [String, Object as () => TranslateResult]
		},
		fancy: Boolean,
		value: {
			type: Object as () => Purchase
		},
		multiple: {
			type: Boolean,
			default: false
		},
		showSearchButton: {
			type: Boolean,
			default: true
		},
		compactSearch: {
			type: Boolean,
			default: false
		},
	},
	methods: {
		openBrowseModal() {
			this.browseModalOpen = true;
		},
		async onBrowseItemSelected(purchase: Purchase) {
			purchase = await PurchaseService.getPurchase(purchase.ID);
			this.browseModalOpen = false;
			this.$emit("input", purchase);
		},
		async onBrowseItemsSelectedMultiple(purchases:Purchase[]) {
			let r = [];
			for (const purchase of purchases) {
				let s = await PurchaseService.getPurchase(purchase.ID);
				r.push(s);
			}
			this.browseModalOpen = false;
			this.$emit("batch", r);
		},
	},
	async mounted(){
		if(this.generalSettings.DefaultPurchaseF3Browse>0){
			this.view = await ViewService.getView(this.generalSettings.DefaultPurchaseF3Browse);
		}
	},
	components: {
		AppPurchaseSearch,
		AppPurchaseBrowse
	},
	i18nEx: {
		componentPrefix: "components.purchases"
	}
});
